import * as XLSX from 'xlsx';

export const CSV_SEPARATOR: string = ',';
const CSV_SEPARATOR_INSTRUCTION: string = ['sep=', CSV_SEPARATOR, '\n'].join('');
const UNIVERSAL_BOM: string = '\uFEFF';
enum MIME_TYPE {
  PDF = 'application/pdf',
  CSV = 'text/csv;charset=utf-8',
  MsWord = 'application/msword',
  ZIP = 'application/zip',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

export function downloadZip(data: string | Blob, filename?: string): void {
  const blob = data instanceof Blob ? data : new Blob([data], { type: MIME_TYPE.ZIP });
  downloadBlob(blob, filename);
}

export function downloadFile(blob: Blob, filename?: string): void {
  downloadBlob(blob, filename);
}

export function downloadCsv(data: string, filename?: string, locale?: string): boolean | string | void {
  const blob = new Blob(
    [isUniversalBomEnabled(locale) ? UNIVERSAL_BOM + data : CSV_SEPARATOR_INSTRUCTION.concat(data)],
    {
      type: MIME_TYPE.CSV,
    },
  );

  if (filename) {
    const sanitizedFilename = new RegExp(/\.csv$/).test(filename) ? filename : `${filename}.csv`;
    downloadBlob(blob, sanitizedFilename);
  } else {
    downloadBlob(blob, `data.csv`);
  }

  return data;
}

export function downloadExcel(workbook: XLSX.WorkBook, filename: string): boolean | string | void {
  const sanitizedFilename = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;
  XLSX.writeFile(workbook, sanitizedFilename, { compression: true });
}

function downloadBlob(blob: Blob, filename?: string): void {
  const url = window.URL.createObjectURL(blob);
  const link: HTMLAnchorElement = window.document.createElement('a');
  link.setAttribute('href', url);
  if (filename) {
    link.setAttribute('download', filename);
  } else {
    link.setAttribute('target', '_blank');
  }
  window.document.body.appendChild(link);

  if (typeof link.click === 'function') {
    link.click();
  }
  window.document.body.removeChild(link);
}

export function isUniversalBomEnabled(locale?: string) {
  const normalizedLocale = locale?.toLowerCase().split(/[-_]/u)[0];
  switch (normalizedLocale) {
    case 'ja':
    case 'fr':
    case 'it':
    case 'de':
      return true;
    default:
      return false;
  }
}
